import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CityPairSelectorModule } from '@dynamic-components/booker-v2/shared/city-pair-selector';
import { JBMessageBlockModule } from '@shared/jb-message-block';
import { PipesModule, UIModule } from '@shared/ui';
import { SkeletonModule } from '@skeleton/skeleton.module';
import {
  JbActionModule,
  JbExpandableButtonModule,
  JbExpandableContainerModule,
  JbFormFieldContainerModule,
  JbSrOnlyModule,
  JbTabsModule,
} from 'jb-component-library';

import {
  FlightTrackerComponent,
  flightTrackerResolver,
} from './flight-tracker.component';
import { FlightTrackerResultsComponent } from './flight-tracker-results';
import { FlightTrackerMobileAlertLabelComponent } from './flight-tracker-results/flight-tracker-mobile-alert-label/flight-tracker-mobile-alert-label.component';
import { FlightTrackerResultsAnimationComponent } from './flight-tracker-results/flight-tracker-results-animation/flight-tracker-results-animation.component';
import { FlightTrackerResultsConnectingComponent } from './flight-tracker-results/flight-tracker-results-connecting/flight-tracker-results-connecting.component';
import { FlightTrackerResultsDesktopDialogComponent } from './flight-tracker-results/flight-tracker-results-desktop-dialog/flight-tracker-results-desktop-dialog.component';
import { FlightTrackerResultsDialogComponent } from './flight-tracker-results/flight-tracker-results-dialog/flight-tracker-results-dialog.component';
import { FlightTrackerResultsDirectComponent } from './flight-tracker-results/flight-tracker-results-direct/flight-tracker-results-direct.component';
import { FlightTrackerResultsAnimationMessageSectionComponent } from './flight-tracker-results/shared/flight-tracker-results-animation-message-section/flight-tracker-results-animation-message-section.component';
import { FlightTrackerResultsArrivalColumnComponent } from './flight-tracker-results/shared/flight-tracker-results-arrival-column/flight-tracker-results-arrival-column.component';
import { FlightTrackerResultsCenterArrowColumnComponent } from './flight-tracker-results/shared/flight-tracker-results-center-arrow-column/flight-tracker-results-center-arrow-column.component';
import { FlightTrackerResultsDepartureColumnComponent } from './flight-tracker-results/shared/flight-tracker-results-departure-column/flight-tracker-results-departure-column.component';
import { FlightTrackerResultsDestinationColumnComponent } from './flight-tracker-results/shared/flight-tracker-results-destination-column/flight-tracker-results-destination-column.component';
import { FlightTrackerResultsFlightnoColumnComponent } from './flight-tracker-results/shared/flight-tracker-results-flightno-column/flight-tracker-results-flightno-column.component';
import { FlightTrackerResultsInboundPlaneComponent } from './flight-tracker-results/shared/flight-tracker-results-inbound-plane/flight-tracker-results-inbound-plane.component';
import { FlightTrackerResultsOriginColumnComponent } from './flight-tracker-results/shared/flight-tracker-results-origin-column/flight-tracker-results-origin-column.component';
import { FlightTrackerResultsStatusColumnComponent } from './flight-tracker-results/shared/flight-tracker-results-status-column/flight-tracker-results-status-column.component';
import { flightTrackerRoutes } from './flight-tracker-routing.module';
import { FlightTrackerSearchComponent } from './flight-tracker-search/flight-tracker-search.component';

const MODULES = [
  CityPairSelectorModule,
  CommonModule,
  FormsModule,
  JBMessageBlockModule,
  JbActionModule,
  JbExpandableButtonModule,
  JbExpandableContainerModule,
  JbFormFieldContainerModule,
  JbSrOnlyModule,
  JbTabsModule,
  PipesModule,
  ReactiveFormsModule,
  SkeletonModule,
  UIModule,
];

const DECLARATIONS = [
  FlightTrackerComponent,
  FlightTrackerMobileAlertLabelComponent,
  FlightTrackerResultsAnimationComponent,
  FlightTrackerResultsAnimationMessageSectionComponent,
  FlightTrackerResultsArrivalColumnComponent,
  FlightTrackerResultsCenterArrowColumnComponent,
  FlightTrackerResultsComponent,
  FlightTrackerResultsConnectingComponent,
  FlightTrackerResultsDepartureColumnComponent,
  FlightTrackerResultsDesktopDialogComponent,
  FlightTrackerResultsDestinationColumnComponent,
  FlightTrackerResultsDialogComponent,
  FlightTrackerResultsDirectComponent,
  FlightTrackerResultsFlightnoColumnComponent,
  FlightTrackerResultsInboundPlaneComponent,
  FlightTrackerResultsOriginColumnComponent,
  FlightTrackerResultsStatusColumnComponent,
  FlightTrackerSearchComponent,
];

@NgModule({
  imports: [...MODULES, flightTrackerRoutes],
  declarations: [...DECLARATIONS],
  exports: [...MODULES, ...DECLARATIONS],
})
export class FlightTrackerModule {
  static entry = FlightTrackerComponent;
  static componentDataResolver = flightTrackerResolver;
}
